// extracted by mini-css-extract-plugin
module.exports = {"container":"idt-aspectratio_container__3ubzc","element":"idt-aspectratio_element__3g1ba"};